import { render, staticRenderFns } from "./RelatorioDeclaracao.vue?vue&type=template&id=eed6a9ae&scoped=true&"
import script from "./RelatorioDeclaracao.vue?vue&type=script&lang=js&"
export * from "./RelatorioDeclaracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed6a9ae",
  null
  
)

export default component.exports